import { styled } from '@mui/material/styles';
import { Checkbox as MuiCheckbox } from '@mui/material';

const Checkbox = styled(MuiCheckbox)`
  margin: -5px -9px;
`;

export default Checkbox;
